"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _consts = require("../utils/layout/consts");
var _tailwind = require("../common/tailwind");
const LinkList = ({
  direction = "column",
  indent,
  legacy,
  useMargin = legacy,
  spacing = _consts.SPACINGS.FOUR_HUNDRED,
  children,
  dataTest
}) => /*#__PURE__*/React.createElement("ul", {
  "data-test": dataTest,
  className: (0, _clsx.default)("flex", "w-full", "m-0", "list-none", "text-normal", indent && "ps-100 p-0", direction && (0, _tailwind.getDirectionClasses)(direction), spacing && (0, _tailwind.getSpacingClasses)(spacing, undefined, direction, useMargin))
}, React.Children.map(children, item => {
  if (! /*#__PURE__*/React.isValidElement(item)) return null;
  return /*#__PURE__*/React.createElement("li", {
    className: (0, _clsx.default)("[&_.orbit-text-link]:no-underline", direction === "column" && "tb:[&_.orbit-text-link]:w-auto w-full [&_.orbit-text-link]:w-full")
  }, item);
}));
var _default = exports.default = LinkList;